import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';

export default function SubmitButton({
  children,
  className,
  isSubmitting,
  isValid,
  title,
  ...rest
}) {
  return (
    <Button
      type="primary"
      htmlType="submit"
      className={className}
      loading={isSubmitting}
      disabled={!isValid || isSubmitting}
      {...rest}
    >
      {children || title}
    </Button>
  );
}

SubmitButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  title: PropTypes.string,
};

SubmitButton.defaultProps = {
  children: null,
  className: undefined,
  isSubmitting: false,
  isValid: true,
  title: undefined,
};
